import { createSelector } from '@reduxjs/toolkit';
import { RootState } from '../../store';

const selectRoot = ({ prices }: RootState) => prices;

export const selectPrices = createSelector(
    selectRoot,
    ({ prices }) => prices,
);
